<template>
  <div>
    <q-btn color="primary" class="q-mb-md" icon="mdi-plus" no-caps @click="openCreateDialog">
      {{ $t('register_coupon') }}
    </q-btn>

    <CampaignCouponDialog
      v-model="dialogVisible"
      :campaign-id="id"
      :channels-list="channelsList"
      :coupon="selectedCoupon"
      @saved="onCouponSaved"
    />
  </div>
</template>

<script>
import AdvertiserService from '../../services/AdvertiserService';
import CampaignMixin from '../../mixins/CampaignMixin';
import CampaignCouponDialog from './CampaignCouponDialog.vue';

export default {
  name: 'HeaderCampaignCoupons',
  components: { CampaignCouponDialog },
  mixins: [AdvertiserService, CampaignMixin],
  props: {
    id: {
      type: [String, Number],
      required: true
    },
    channelsList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogVisible: false,
      selectedCoupon: null
    };
  },
  methods: {
    openCreateDialog() {
      this.selectedCoupon = null;
      this.dialogVisible = true;
    },

    openEditDialog(coupon) {
      this.selectedCoupon = { ...coupon };
      this.dialogVisible = true;
    },

    onCouponSaved() {
      this.$emit('refresh');
    }
  }
};
</script>
